import { WarehouseDto } from '@app/store/shared/models';

export class Warehouse {
    id: string;
    code: string;
    name: string;
    type: string;
    grossWeight: boolean;

    constructor(data: WarehouseDto) {
        this.id = data.id;
        this.code = data.code;
        this.name = data.name;
        this.type = data.type;
        this.grossWeight = data.grossWeight;
    }
}
